package com.vidaensupalabra.vsp.ventanas

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import kotlin.random.Random

@Composable
fun YouTubeVideoPlayer(videoId: String, autoplay: Boolean = false) {
    // Generar un ID único para evitar colisiones si el mismo video se renderiza dos veces
    val containerId = remember(videoId) { "yt-player-${videoId}-${Random.nextInt(10000)}" }
    
    Div(
        attrs = {
            id(containerId)
            style {
                width(100.percent)
                height(100.percent)
                backgroundColor(Color.black) // Previene destellos visuales mientras carga el iframe
            }
        }
    )

    DisposableEffect(videoId) {
        window.asDynamic().initYouTubeVideo(containerId, videoId, autoplay)
        onDispose {
            window.asDynamic().destroyYouTubeVideo(containerId)
        }
    }
}